#@import Booking.Collections.Base
#@import Booking.Models.PartySize
#@export Booking.Collections.PartySizes

class Booking.Collections.PartySizes extends Booking.Collections.Base
  model: Booking.Models.PartySize
